/* tslint:disable */

/**
 */
export class SizingResultOptimum {
    tsMax?: number;
    ts?: number;
    vc?: number;
    dhp?: number;
    conso?: string;
    conso_warning?: string;
    toc?: number;
    tr?: number;
    trMax?: number;
    vcMax?: number;
    dhpMax?: number;
    consoMax?: string;
    consomax_warning?: string;
    tocMax?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/sizing-result-optimum.ts